export default __webpack_public_path__ + "static/media/chart.92d2eb3c.svg";